<template>
    <v-content>
        <v-container fluid fill-height>
            <v-layout row wrap>
                <v-flex xs12> 
                    <h2 style="font-family: Lato; margin-left: 10px">
                        <span style="color: white">
                            <span class="capitalLetter">E</span>quipment</span>
                        <span style="color: white">
                            <span class="capitalLetter">S</span>tock</span>
                        <span style="color: white">
                            <span class="capitalLetter">L</span>evels</span>
                    </h2>
                    <v-spacer></v-spacer>
                    <totalStockTable v-if="!isLoading" :equipment-list="allEquipment" :search="search" :is-loading="isLoading"/>
                    <v-spacer v-if="isLoading">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-spacer>
                </v-flex>
                <v-flex xs12>
                    <hr style="margin-top: 30px; margin-bottom: 30px; margin-left: 10px; margin-right: 10px">
                </v-flex>
                <v-flex xs12>
                  <mymap name="mapName"></mymap>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
const axios = require("axios");
import getSitePass from "../sitepass";
import mymap from "../components/map.vue";
import totalStockTable from '../components/tables/totalStockTable.vue'

export default {
    name: "mainstock",
    components: { mymap, totalStockTable },
    data: function () {
        return {
            allEquipment: [],
            isLoading: true,
            search: ""
        }
    },
    methods: {
        getMainStock() {
            axios
                .get(process.env.VUE_APP_backend_url, {
                    params: {
                        sitepass: getSitePass()
                    }
                })
                .then((response) => {
                    this.allEquipment = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        initialize() {
            this.getMainStock();
        }
    },
    created() {
        this.initialize();
    }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/totalStockView.vue